import TeamJersey from './TeamJersey';

interface TeamsJerseysProps {
  homeJerseySrc: string;
  awayJerseySrc: string;
  homeTeamName: string;
  awayTeamName: string;
}

const TeamsJerseys = ({
  homeJerseySrc,
  awayJerseySrc,
  homeTeamName,
  awayTeamName,
}: TeamsJerseysProps) => (
  <div className="flex justify-between gap-4 px-5">
    <TeamJersey jerseySrc={homeJerseySrc} teamName={homeTeamName} />
    <TeamJersey jerseySrc={awayJerseySrc} teamName={awayTeamName} />
  </div>
);

export default TeamsJerseys;
